<div class="card">
  <app-header
    [titulo]="'Endpoints da Conexão: ' + (conexao?.nome || '')"
    [descricao]="'Cadastre os caminhos que os processos podem chamar' + (conexao?.provedorNome ? ' em ' + conexao?.provedorNome : '')">
  </app-header>

  <div class="info-message mb-3" *ngIf="conexao">
    <i class="pi pi-link"></i>
    <span>
      URL base desta conexão: <strong>{{ conexao.config?.url_base || conexao.urlBase || 'não informada' }}</strong>.
      Informe abaixo apenas o caminho de cada rota, por exemplo <code>/pedidos</code>. Ele será acrescentado à URL base.
    </span>
  </div>

  <p-toolbar styleClass="mb-4">
    <ng-template pTemplate="left">
      <p-button label="Novo Endpoint (rota)" icon="pi pi-plus" severity="success" (onClick)="novoEndpoint()"></p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <p-button label="Voltar" icon="pi pi-arrow-left" severity="secondary" (onClick)="voltar()"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table [value]="endpoints" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="metodo" style="width: 8rem">Método <p-sortIcon field="metodo"></p-sortIcon></th>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="path">Caminho <p-sortIcon field="path"></p-sortIcon></th>
        <th pSortableColumn="tipoApi" style="width: 9rem">Tipo <p-sortIcon field="tipoApi"></p-sortIcon></th>
        <th style="width: 16rem">Autenticação</th>
        <th style="width: 8rem">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-endpoint>
      <tr>
        <td><p-tag [value]="endpoint.metodo" [severity]="severidadeMetodo(endpoint.metodo)"></p-tag></td>
        <td>
          <strong>{{ endpoint.nome }}</strong>
          <!-- Endpoint legado sem public_id: a API só endereça endpoints por esse identificador -->
          <p-tag *ngIf="!endpoint.id" class="ml-2" value="Legado" severity="warning"
            pTooltip="Endpoint antigo sem identificador: a API não consegue abri-lo nem alterá-lo. Peça ao backend a migração dos identificadores." tooltipPosition="top"></p-tag>
        </td>
        <td><code>{{ endpoint.path }}</code></td>
        <td>
          <p-tag
            [value]="endpoint.tipoApi"
            [severity]="endpoint.tipoApi === TipoApi.JSON || endpoint.tipoApi === TipoApi.SOAP ? 'secondary' : 'warning'"
            [pTooltip]="endpoint.tipoApi === TipoApi.JSON || endpoint.tipoApi === TipoApi.SOAP ? '' : 'O runtime só executa endpoints JSON e SOAP'"
            tooltipPosition="top">
          </p-tag>
        </td>
        <td>{{ descricaoAutenticacao(endpoint) }}</td>
        <td>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text" pTooltip="Editar" [attr.aria-label]="'Editar ' + endpoint.nome" tooltipPosition="top" [disabled]="!endpoint.id" (click)="editarEndpoint(endpoint)"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" pTooltip="Excluir" [attr.aria-label]="'Excluir ' + endpoint.nome" tooltipPosition="top" [disabled]="!endpoint.id" (click)="deletarEndpoint(endpoint)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center p-4">Nenhum endpoint cadastrado. Use <strong>Novo Endpoint (rota)</strong> para adicionar um caminho da API.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog de Adicionar/Editar Endpoint -->
<p-dialog
  [(visible)]="endpointDialog"
  [style]="{width: '760px'}"
  [breakpoints]="{'960px': '90vw', '640px': '96vw'}"
  [contentStyle]="{'max-height': '72vh'}"
  [header]="isEditDialog ? 'Editar rota da API' : 'Nova rota da API'"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">
  <ng-template pTemplate="content">
    <div class="p-fluid grid conteudo-dialog" [formGroup]="form">
      <div class="col-12 form-section-heading first-section">
        <h3>1. Identificação</h3>
        <p>Use um nome que ajude a reconhecer esta rota nos comandos do processo.</p>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <input
            pInputText
            id="nome"
            formControlName="nome"
            [class.ng-invalid]="campoInvalido('nome')"
            [class.ng-dirty]="campoInvalido('nome')"
          />
          <label for="nome">Nome da rota *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('nome')">
          Nome é obrigatório (mínimo 3 caracteres)
        </small>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <textarea pInputTextarea id="descricao" formControlName="descricao" rows="2"></textarea>
          <label for="descricao">Descrição</label>
        </p-floatLabel>
      </div>

      <div class="col-12 form-section-heading">
        <h3>2. Chamada da API</h3>
        <p>Escolha o método e informe o caminho que será acrescentado à URL base da conexão.</p>
      </div>

      <div class="field col-12 md:col-4">
        <p-floatLabel>
          <p-dropdown
            id="metodo"
            formControlName="metodo"
            [options]="metodos"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            [style]="{'width':'100%'}"
          ></p-dropdown>
          <label for="metodo">Método *</label>
        </p-floatLabel>
      </div>

      <div class="field col-12 md:col-8">
        <p-floatLabel>
          <input
            pInputText
            id="path"
            formControlName="path"
            [placeholder]="placeholderPath"
            [class.ng-invalid]="campoInvalido('path')"
            [class.ng-dirty]="campoInvalido('path')"
          />
          <label for="path">Caminho da rota *</label>
        </p-floatLabel>
        <small class="p-error" *ngIf="campoInvalido('path')">
          Path é obrigatório
        </small>
        <small class="p-text-secondary">{{ dicaPath }}</small>
        <small class="aviso" *ngIf="avisoPath">
          <i class="pi pi-exclamation-triangle"></i> {{ avisoPath }}
        </small>
        <small class="aviso" *ngIf="avisoDuplicado">
          <i class="pi pi-exclamation-triangle"></i> Já existe um endpoint com este método e path nesta conexão.
        </small>
        <small class="aviso" *ngIf="avisoPathLogin">
          <i class="pi pi-exclamation-triangle"></i> {{ avisoLoginTexto }}
        </small>
      </div>

      <div class="field col-12 md:col-6">
        <p-floatLabel>
          <p-dropdown
            id="tipoApi"
            formControlName="tipoApi"
            [options]="tiposApi"
            optionLabel="label"
            optionValue="value"
            optionDisabled="disabled"
            appendTo="body"
            [style]="{'width':'100%'}"
          ></p-dropdown>
          <label for="tipoApi">Tipo da API *</label>
        </p-floatLabel>
        <small class="p-text-secondary">O runtime só executa JSON e SOAP.</small>
      </div>

      <!-- SOAP -->
      <ng-container *ngIf="tipoApiSelecionado === TipoApi.SOAP">
        <div class="col-12">
          <h6 class="subsection-title">Configuração SOAP</h6>
          <p class="form-section-description">Preencha estes campos somente se a API usar SOAP.</p>
        </div>

        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input pInputText id="soapAction" formControlName="soapAction" placeholder="urn:MinhaAcao" />
            <label for="soapAction">SOAPAction</label>
          </p-floatLabel>
          <small class="p-text-secondary">Enviado no cabeçalho SOAPAction da requisição.</small>
        </div>

        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input pInputText id="xmlElementoItem" formControlName="xmlElementoItem" placeholder="Item" />
            <label for="xmlElementoItem">Elemento de item da resposta</label>
          </p-floatLabel>
          <small class="p-text-secondary">Nome do elemento XML repetido que será extraído como registro.</small>
        </div>

        <div class="field col-12">
          <div class="field-checkbox">
            <p-inputSwitch inputId="xmlSoapResponse" formControlName="xmlSoapResponse"></p-inputSwitch>
            <label for="xmlSoapResponse">A resposta é um envelope SOAP</label>
          </div>
        </div>
      </ng-container>

      <!-- Autenticação -->
      <div class="col-12 form-section-heading">
        <h3>3. Autenticação e tokens</h3>
        <p>Marque as opções que descrevem esta rota. Uma rota de login gera um token; as demais podem consumi-lo.</p>
      </div>

      <div class="field col-12 md:col-6">
        <div class="field-checkbox">
          <p-inputSwitch inputId="requerAutenticacao" formControlName="requerAutenticacao"></p-inputSwitch>
          <label for="requerAutenticacao">Requer autenticação</label>
        </div>
        <small class="p-text-secondary">
          Envia o token como <code>Authorization: Bearer</code>.
        </small>
      </div>

      <div class="field col-12 md:col-6">
        <div class="field-checkbox">
          <p-inputSwitch inputId="geraToken" formControlName="geraToken"></p-inputSwitch>
          <label for="geraToken">Este endpoint faz login (gera um token)</label>
        </div>
        <small class="p-text-secondary">
          Usado por um recurso de Autenticação; o token fica disponível para os demais endpoints.
        </small>
      </div>

      <!-- Consumo de token -->
      <ng-container *ngIf="requerAutenticacao">
        <div class="field col-12">
          <p-floatLabel>
            <input
              pInputText
              id="tokenConsumido"
              formControlName="tokenConsumido"
              list="tokens-conhecidos"
              autocomplete="off"
            />
            <label for="tokenConsumido">Nome do token a enviar (opcional)</label>
          </p-floatLabel>
          <datalist id="tokens-conhecidos">
            <option *ngFor="let t of tokensConhecidos" [value]="t"></option>
          </datalist>
          <small class="p-text-secondary" *ngIf="tokenConsumidoVazio">
            Em branco: usa só a credencial estática da conexão (se houver). Para usar um token de login, informe o
            nome dado por um endpoint de login<ng-container *ngIf="tokensConhecidos.length"> (sugestões: {{ tokensConhecidos.join(', ') }})</ng-container>.
          </small>
          <small class="aviso" *ngIf="avisoTokenDesconhecido">
            <i class="pi pi-exclamation-triangle"></i>
            Nenhum endpoint de login desta conexão gera esse token. Vale se ele vier de um recurso de Autenticação
            de outra conexão; caso contrário a execução falha.
          </small>
        </div>
      </ng-container>

      <!-- Endpoint de login -->
      <ng-container *ngIf="geraToken">
        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              id="tokenName"
              formControlName="tokenName"
              placeholder="TOKEN_ZEUS"
              [class.ng-invalid]="campoInvalido('tokenName')"
              [class.ng-dirty]="campoInvalido('tokenName')"
            />
            <label for="tokenName">Nome do token *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('tokenName')">Informe o nome sob o qual o token será guardado</small>
          <small class="p-text-secondary">Nome usado pelos endpoints que consomem o token.</small>
        </div>

        <div class="field col-12 md:col-6">
          <p-floatLabel>
            <input
              pInputText
              id="tokenPath"
              formControlName="tokenPath"
              placeholder="user.token"
              [class.ng-invalid]="campoInvalido('tokenPath')"
              [class.ng-dirty]="campoInvalido('tokenPath')"
            />
            <label for="tokenPath">Caminho do token na resposta *</label>
          </p-floatLabel>
          <small class="p-error" *ngIf="campoInvalido('tokenPath')">Informe o caminho do token na resposta do login</small>
          <small class="p-text-secondary">Separado por pontos, ex.: user.token ou access_token.</small>
        </div>

        <div class="field col-12">
          <p-floatLabel>
            <input
              pInputText
              id="contentTypeLogin"
              formControlName="contentTypeLogin"
              placeholder="application/x-www-form-urlencoded"
            />
            <label for="contentTypeLogin">Content-Type do login (opcional)</label>
          </p-floatLabel>
          <small class="p-text-secondary">Em branco: application/json.</small>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" [disabled]="salvando" (click)="fecharDialog()"></button>
    <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-success" [loading]="salvando" (click)="salvarEndpoint()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
